import { ColorModeScript } from '@chakra-ui/react';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import Providers from './components/Providers';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
import HotjarProvider from './contexts/HotjarContext';

ReactDOM.render(
  <StrictMode>
    <ColorModeScript />
    <Providers>
      <HotjarProvider>
        <App />
      </HotjarProvider>
    </Providers>
  </StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
